var map = {
	"./actions": 2782,
	"./actions.json": 2782,
	"./alert": 7835,
	"./alert.json": 7835,
	"./attributes": 6294,
	"./attributes.json": 6294,
	"./common": 5458,
	"./common.json": 5458,
	"./competition": 6354,
	"./competition.json": 6354,
	"./confirm-password": 7729,
	"./confirm-password.json": 7729,
	"./contact": 5853,
	"./contact.json": 5853,
	"./costs": 8727,
	"./costs.json": 8727,
	"./dashboard": 1477,
	"./dashboard.json": 1477,
	"./deposit": 475,
	"./deposit.json": 475,
	"./forgot-password": 3894,
	"./forgot-password.json": 3894,
	"./forms": 2830,
	"./forms.json": 2830,
	"./game": 6993,
	"./game.json": 6993,
	"./global": 1332,
	"./global.json": 1332,
	"./home": 9420,
	"./home.json": 9420,
	"./infos-modal": 3016,
	"./infos-modal.json": 3016,
	"./messages": 887,
	"./messages.json": 887,
	"./party": 6701,
	"./party.json": 6701,
	"./profile": 8752,
	"./profile.json": 8752,
	"./pwa": 4497,
	"./pwa.json": 4497,
	"./referral": 3950,
	"./referral.json": 3950,
	"./replay-game": 2689,
	"./replay-game.json": 2689,
	"./report-problem": 6459,
	"./report-problem.json": 6459,
	"./settings": 9286,
	"./settings.json": 9286,
	"./sidebar": 4917,
	"./sidebar.json": 4917,
	"./signin": 6673,
	"./signin.json": 6673,
	"./signup": 1519,
	"./signup.json": 1519,
	"./terms": 6110,
	"./terms.json": 6110,
	"./tips": 1829,
	"./tips.json": 1829,
	"./transaction": 9853,
	"./transaction.json": 9853,
	"./withdrawal": 5136,
	"./withdrawal.json": 5136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1412;